<style lang="scss">
.license-terms{
	.license-title{
		color : #595E63;
		font-size : 18px;
		font-weight: 600;
		border-bottom: 1px solid #e5e5e5;
		padding-bottom: 10px;
	}

	.license-box {
		max-height: 70vh;
		overflow: scroll;
		border: 1px solid;
		padding: 10px;
	}

	.text-success{
		font-size: 24px;
		margin-top: 6px;
	}

	.text-danger{
		font-size: 24px;
		margin-top: 6px;
	}

	.license-item{
		height: 35px;

	}

	.license-text{
		font-size: 16px;
		color: #595E63;
		margin-top: 7px;
	}

	.terms{
		text-align: center;
    	margin-top: 30px;
		font-size: 12px;
	}

	.btn-close{
		padding: 10px 50px !important;
	}

}

@media screen and (max-width: 500px) {
    .license-terms{
        .p-a-lg {
            padding: 2rem !important;
        }

        .btn-close{
            width: 100% !important;
        }
    }
}
</style>

<template>
	<div class="license-terms modal fade" id="license-terms" :style="$modalBackgroundStyle" ref="licenseTermsModal">
		<a data-dismiss="modal" class="text-lg p-x modal-close-btn">×</a>
		 <div class="row-col">
            <div class="p-a-lg h-v row-cell v-m">
                <div class="row">
                    <div class="col-xs-12 col-sm-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
                        <div class="row">
							<h4 class="modal-title" :style="$highlightColor">License Agreement</h4>

							<div v-if="contract">
								<div><strong>{{ license.name }}</strong></div>
								<div ref="licenseModalBox" id="license-modal-box" class="license-box" v-html="contract" :style="$borderColorStyle"></div>
							</div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Configure from "../../mixins/configure"
import SecondaryModal from "../../mixins/secondary-modal"
import {parseAgreementTags} from "../../../../shared/utils/parse-agreement-tags";

export default {
        mounted() {
	        let vm = this
            this.$nextTick(() => {
                $(this.$el).on('hide.bs.modal', () => {
                    $(vm.$refs['licenseModalBox']).scrollTop(0)
                })
            })
        },
		mixins: [Configure, SecondaryModal],
		computed: {
            license () {
                return this.$store.state.modalLicense
            },
			contract() {
                if (this.license) {
                    let contract = this.license.contract.clean

					return this.formatContract(contract)
                }
			},
            loggedInUser() {
                return this.$store.state.loggedInUser
            }
        },
		methods: {
            formatContract(contract) {
                contract = contract.replace("%MFS_ORDER_DATE%", moment().format('Do MMMM YYYY'))
                contract = contract.replace("%MFS_BEAT_NAME%", "BEAT NAME")
                contract = contract.replace("%ORDER_DATE%", moment().format('Do MMMM YYYY'))
                contract = contract.replace("%BEAT_NAME%", "BEAT NAME")


                if (this.loggedInUser || this.$store.state.name.length > 0) {
                    let customer = this.loggedInUser ? this.loggedInUser.name : this.$store.state.name

                    contract = contract.replace("%MFS_CLIENT_NAME%", customer)
                    contract = contract.replace("%CLIENT_NAME%", customer)
                } else {
                    contract = contract.replace("%MFS_CLIENT_NAME%", "CLIENT NAME HERE")
                    contract = contract.replace("%CLIENT_NAME%", "CLIENT NAME HERE")
                }

                contract = contract && parseAgreementTags(contract)
                return contract
            },
        },
    }
</script>
